
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/case-study/yaticorp",
      function () {
        return require("private-next-pages/case-study/yaticorp.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/case-study/yaticorp"])
      });
    }
  